<template>
  <div class="d-flex flex-column g-0 h100 " v-if="!loading">

    <ToolbarComponent v-if="!$route.meta.fullscreen" :initialData="data.header" :inert="chromeInert" />

    <main id="main-content" class="container-content flex-grow-1" :inert="mainInert ? true : undefined">
      <span class="container-content-inner">
        <router-view />
      </span>
    </main>

    <FooterComponent v-if="!$route.meta.fullscreen" :data="data.footer" :inert="chromeInert ? true : undefined" />

    <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup" :variant="popupVarient" :containerClass="popupContainerClass">
      <CartPopupComponent :url="popupUrl" @close="closePopup"></CartPopupComponent>
      <PopupRendererComponent :url="popupUrl" :content="popupData" :campaignOffer="campaignOffer" @close="closePopup"></PopupRendererComponent>
    </PopupComponent>
    <PopupComponent :showClose="false" v-if="showSelectCity" @close="closePopup">
      <SelectCityPopup @close="closePopup"></SelectCityPopup>
    </PopupComponent>
    <PopupComponent :showClose="false" v-if="showSearchPopup" @close="closePopup">
      <SearchPopupComponent @close="closePopup" :forceSearch="true" />
    </PopupComponent>

    <PopupComponent :showClose="true" v-if="showNewsletterSubscribe" @close="closePopup" colorVariant="red">
      <NewsletterSubscribePopup @close="closePopup" :data="data.newsletter_subscribe_popup" />
    </PopupComponent>
    <NewsletterSubscribeOpenByEventComponent />
    <FloatingCartComponent :inert="chromeInert ? true : undefined" />
    <JumpToTopComponent v-if="showJumpToTopChrome" />
  </div>

</template>

<script>
// @ is an alias to /src
import ToolbarComponent from '@/components/site/ToolbarComponent.vue'
import FooterComponent from '@/components/site/FooterComponent.vue'
import PopupComponent from '@/components/PopupComponent.vue'
import PopupRendererComponent from '@/components/popup/PopupRendererComponent.vue'
import CartPopupComponent from '@/components/popup/CartPopupComponent.vue'
import SelectCityPopup from '@/views/popup/SelectCityPopup.vue'
import FloatingCartComponent from '@/components/floating/FloatingCartComponent.vue'
import JumpToTopComponent from '@/components/floating/JumpToTopComponent.vue'
import SearchPopupComponent from '@/components/popup/SearchPopupComponent.vue';
// import LoadingWrapper from '@/components/LoadingWrapper.vue'
import {fetch2} from '@/modules/configuration.js'
import NewsletterSubscribeOpenByEventComponent from '@/components/NewletterSubscribeOpenByEventComponet.vue'
import NewsletterSubscribePopup from '@/views/popup/NewsletterSubscribePopup.vue';
export default {
  components: {
    ToolbarComponent,
    FooterComponent,
    PopupComponent,
    SelectCityPopup,
    NewsletterSubscribeOpenByEventComponent,
    PopupRendererComponent,
    CartPopupComponent,
    FloatingCartComponent,
    JumpToTopComponent,
    SearchPopupComponent,
    NewsletterSubscribePopup
    // LoadingWrapper
  },
  data() {
    return {
      loading: true,
      showSearchPopup: false,
      data: {}
    }
  },
  mounted() {
    if (this.$route.meta.fullscreen) {
      this.loading = false;
      return;
    }
    this.getData();
  },
  computed: {
    dishDrawerOpen() {
      return !!this.$route.params.dishid;
    },
    chromeInert() {
      return this.showSearchPopup || this.showPopup || this.showSelectCity || this.dishDrawerOpen;
    },
    mainInert() {
      return this.showSearchPopup || this.showPopup || this.showSelectCity;
    },
    showPopup() {
      return this.$store.state.popupOpen;
    },
    popupVarient() {
      return this.$store.state.popupVarient;
    },
    showSelectCity() {
      return this.$store.state.selectCityOpen;
    },
    showNewsletterSubscribe() {
      return this.$store.state.newsletterSubscribeOpen && this.data.newsletter_subscribe_popup;
    },
    popupData() {
      return this.$store.state.popupData;
    },
    popupUrl() {
      return this.$store.state.popupUrl;
    },
    popupContainerClass() {
      if (this.popupData?.form?.hosted_fields && !this.popupData?.form?.auth_code) {
        return 'mw820 tranzila-hf-popup';
      }
      return 'mw820';
    },
    showJumpToTopChrome() {
      if (this.$route.meta.fullscreen) return false;
      if (this.$route.name === 'preview_picture') return false;
      return this.$store.state.showJumpToTop;
    },
    campaignOffer() {
      return this.$store.state.campaignPopupOpen;
    },
  },
  methods: {
    showOrHoldGenericPromotion(payload) {
      if (!payload) return;
      if (this.$store.state.campaignPopupOpen) {
        this.$store.dispatch('setPendingGenericPromotion', payload);
        return;
      }
      this.$store.dispatch('showPopup', payload, 'center');
    },
    closePopup(success, response, requestId) {
      const wasCampaignOffer = this.$store.state.campaignPopupOpen;
      const pendingGenericPromotion = this.$store.state.pendingGenericPromotion;
      this.showSearchPopup = false;
      this.$store.dispatch('hidePopup');
      this.$store.dispatch('hideSelectCity');
      this.$store.dispatch('hideNewsletterSubscribe');
      if (wasCampaignOffer) {
        this.$store.dispatch('setCampaignPopupOpen', false);
        this.$store.dispatch('clearPendingGenericPromotion');
        if (pendingGenericPromotion) {
          this.$store.dispatch('showPopup', pendingGenericPromotion, 'center');
        }
      }
      if (success) {
        this.emitter.emit("silent-refresh", {success: true, data: response, requestId: requestId});
      }
    },
    async getData() {
      const data = await fetch2(this, "/outer");
      if (!data || Object.keys(data).length === 0) {
        this.loading = false;
        return;
      }

      this.data = data;
      const campaign = data.subscribe_to_newsletter_campaign_popup;
      if (campaign?.popup === true && campaign?.popup_content) {
        this.$store.dispatch('setCampaignPopupOpen', true);
        this.$store.dispatch('showPopup', campaign.popup_content, 'center');
      }
      this.loading = false;
      if (data.facebook_connect_data) {
        this.addFacebookCode(data.facebook_connect_data);
      }
      
      // Check for general popup and show it
      if (data?.generic_promotion) {
        this.showOrHoldGenericPromotion(data.generic_promotion);
      }
      

    },
    addFacebookCode(fbData) {
      window.fbData = fbData;
      window.fbAsyncInit = function () {
        // eslint-disable-next-line 
        FB.init({
          appId: fbData.appID,
          version: fbData.api_version,
          xfbml: true
        });
      };

      // load facebook sdk script
      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

    }
  },
  watch: {
    async $route(to/*, from*/) {
      if (to.hash === "#cart") {
        this.closePopup();
        await this.$nextTick();
        this.$store.dispatch('showPopupWithUrl', "/orders/cart_panel");
      }
      if (to.hash === "#popup:select_city") {
        const loc = window.location;
        history.pushState("", document.title, loc.pathname + loc.search);
        this.$store.dispatch('showSelectCity');
      }
      if (to.hash === "#popup:search_popup") {
        const loc = window.location;
        history.pushState("", document.title, loc.pathname + loc.search);
        this.showSearchPopup = true;
      }
    }
  }
}
</script>
<style scoped>
.container-content {
  margin: 0 20px 20px;
}

.container-content-inner {
  min-width: 320px;
  display: block;
  margin: 0;
  padding: 0;
}
@media (min-width: 768px) {
  .container-content {
    /* margin: 0 110px 110px; */
    margin: 0 20px 20px;
  }
}

@media (min-width: 1200px) {
  .container-content {
    /* margin: 0 110px 110px; */
    margin: 0;
  }

  .container-content-inner {
    margin-top: 63px !important;
  }
}
</style>
